import type { Question } from '../services/api';

/** WITC questions arrive with empty `answers` in play payloads; MC has alternatives. */
export function isQuickMatchWitcQuestion(q: Question): boolean {
  return !q.answers || q.answers.length === 0;
}
